export default {
  area: "三门峡居民养老",
  objectName: "三门峡居民养老",
  point: { lng: 112.384568, lat: 34.672387 },
  mapAttr: {
    mapType: "BMAP_NORMAL_MAP",
    zoom: 17
  },
  //url
  hostUrl: 'https://ymzhyl.anluoyun.cn',
  apiHttpsUrl: 'https://ymzhyl.anluoyun.cn/prod-api',
  apiRequestUrl: 'https://ymzhyl.anluoyun.cn/prod-api',
  apiUploadUrl: 'https://ymzhyl.anluoyun.cn/prod-api/upload/uploadImage',
  apiUploadFiles: 'https://ymzhyl.anluoyun.cn/prod-api/upload/uploadImage',
  apiRequestUrlOrgan: 'https://ymzhylso.anluoyun.cn/prod-api/So/',
  logo: require("../../src/assets/logo.png")
}